<template>
  <div class="d-flex flex-column align-center container">
    <img src="@/assets/healthpass.png" alt class="headerImg" />
    <img class="sideImg" src="@/assets/sideImg.png" alt />
    <router-view class="routerView mb-10"></router-view>
<!-- 
    <div class="d-flex flex-column align-center mt-auto">
      <div class="subtitle-1 font-weight-bold mb-2">Partner of:</div>
      <div class="d-flex logos">
        <a href="https://cellex.gr/" target="_blank">
          <img src="@/assets/cellex.png" />
        </a>
        <img src="@/assets/brainz.png" />
      </div>
    </div>

    <div class="d-flex flex-column align-center dn2me-logo mt-5">
      <div class="subtitle-1 font-weight-bold mb-2">Powered by:</div>
      <img src="@/assets/authHeader.png" />
    </div> -->

    <Footer class="footer mt-auto" />
  </div>
</template>

<script>
import Footer from "@/components/Footer";
export default {
  components: {
    Footer
  }
};
</script>

<style lang="scss" scoped>
.container {
  min-height: 100vh;
}
.footer {
  margin-bottom: 10px;
  margin-top: 20px;
}

.sideImg {
  position: fixed;
  right: -55px;
  bottom: 80px;
  height: 500px;
}

.routerView {
  z-index: 1;
  margin-top: 70px;
}
</style>